import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "File Name",
      key: "name",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Path",
      key: "path",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].path",
    },
    {
      name: "Information Type",
      key: "label",
      spanMin: "13rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].label",
    },

    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "12rem",
      spanMax: "12rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};
